import React from "react";
import {
  Row,
  Modal,
  ModalBody,
  Button,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  alarmDelete,
  alarmEnterEditMode,
  alarmCancelEditMode,
  alarmPreEdit,
  alarmConfirmEdit,
} from "../redux/actions/alarms.action";
import AlarmEdit from "./components/AlarmEdit";
import Alarm from "./components/Alarm";
import WizardAlert from "./components/WizardAlert";
import {
  editDeviceName,
  closeModal,
} from "../redux/actions/modal.devices.action";
const deviceName = /^[\p{L} \-\d]{0,24}$/u;

class Alerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
    };
  }
  handleChangeName = (event) => {
    if (deviceName.test(event.target.value))
      this.setState({ name: event.target.value });
  };
  confirmDeviceName = () => {
    if (!deviceName.test(this.state.name) || !this.state.name.length) {
      return false;
      // send notif
    }
    this.props.editDeviceName(this.state.name);
    this.setState({
      name: "",
    });
  };

  render() {
    return (
      <>
        <div className="content">
          <Modal
            className="modalNewDevice"
            isOpen={
              this.props.modal &&
              this.props.modal.display &&
              this.props.modal.type === "alarm"
            }
            animation={false}
            fade={false}
          >
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
              >
                <i
                  className="tim-icons icon-simple-remove"
                  onClick={() => this.props.closeModal()}
                />
              </button>
              <h6 className="title title-up">
                {this.props.t(`modal.${this.props.modal.title}`)}
              </h6>
            </div>
            <ModalBody className="text-center">
              <p>{this.props.t(`modal.${this.props.modal.description}`)}</p>
              <Input
                style={{ color: "#1e1e2f" }}
                placeholder={this.props.t("common:name")}
                value={this.state.name}
                onChange={this.handleChangeName}
                type="text"
              />
            </ModalBody>
            <div className="modal-footer">
              <Button
                disabled={this.state.name.length < 1}
                color="default"
                type="button"
                onClick={() => this.confirmDeviceName()}
              >
                {this.props.t("common:confirm")}
              </Button>
            </div>
          </Modal>
          {this.props.alarms && this.props.alarms.length ? (
            <>
              <div className="devicesLimit" id="devicesLimit">
                <span id="devicesLimit">{`${this.props.alarms.length}/${
                  this.props.vip.plan < 2 ? "1" : "∞"
                }`}</span>
              </div>
              <UncontrolledTooltip
                delay={2}
                placement="right"
                target="devicesLimit"
              >
                {this.props.t("devicesLimits")}
              </UncontrolledTooltip>
              <Row className="alerts">
                {this.props.alarms.map((a) => {
                  return !a.isEdited ? (
                    <Alarm
                      key={`Alarm-${a.id}`}
                      id={a.id}
                      name={a.name}
                      text={a.text}
                      alarmEnterEditMode={this.props.alarmEnterEditMode}
                      alarmDelete={this.props.alarmDelete}
                    />
                  ) : (
                    <AlarmEdit
                      key={`AlarmEdit-${a.id}`}
                      id={a.id}
                      edit={a.edit}
                      alarmCancelEditMode={this.props.alarmCancelEditMode}
                      alarmPreEdit={this.props.alarmPreEdit}
                      alarmConfirmEdit={this.props.alarmConfirmEdit}
                    />
                  );
                })}
              </Row>
            </>
          ) : (
            <WizardAlert />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { alarms, modal } = state.devices;
  const { vip } = state.infos;
  return { alarms, modal, vip };
};

const mapDispatchToProps = {
  alarmDelete,
  alarmEnterEditMode,
  alarmCancelEditMode,
  alarmPreEdit,
  alarmConfirmEdit,
  editDeviceName,
  closeModal,
};
export default withTranslation(["devices", "common"])(
  connect(mapStateToProps, mapDispatchToProps)(Alerts)
);
